module.exports = __webpack_public_path__ + "img/bg-jy.938e7b5d.png";